module.exports = __webpack_public_path__ + "static/media/imgCard02.dc7ed83d.png";